import { useCallback, useEffect, useMemo, useState } from 'react'

import { loadProfile } from '@/components/Profile/metadata'
import { getDefaultProfileImage } from '@/plugins/auth/AuthProvider/effects/functions'
import { StoredTheme } from '@/utils/utils'

import useL1NS from './useL1NS'
import useLocalStorage from './useLocalStorage'

const useProfilePicture = (creator: string) => {
  // Creator Profile Picture
  const { getL1nsProfile } = useL1NS()
  const [userTheme] = useLocalStorage<StoredTheme>('userTheme')
  const defaultPfp = useMemo(() => getDefaultProfileImage(userTheme?.isLightMode), [userTheme])
  const [creatorPfp, setCreatorPfp] = useState<string>(defaultPfp)
  const [isLoadingPfp, setIsLoadingPfp] = useState<boolean>(false)
  const [isErrorPfp, setIsErrorPfp] = useState<string>('')

  const getCreatorPfp = useCallback(async () => {
    try {
      setIsLoadingPfp(true)
      // Get profile url from contract
      const profileUrl = await getL1nsProfile(creator)

      // Load profile from IPFS
      if (profileUrl) {
        const p = await loadProfile(profileUrl)
        if (p && p.image) {
          setCreatorPfp(p.image)
        } else {
          setCreatorPfp(defaultPfp)
        }
      }
      setIsLoadingPfp(false)
    } catch (e: any) {
      setIsErrorPfp(e.message)
      setIsLoadingPfp(false)
      setCreatorPfp(defaultPfp)
    }
  }, [creator])

  useEffect(() => {
    getCreatorPfp()
  }, [getCreatorPfp])

  return { isErrorPfp, isLoadingPfp, creatorPfp }
}

export default useProfilePicture
